import { createContext } from "react";

export const FieldContext = createContext<{
  labelId?: string;
  hintId?: string;
}>({});
